"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetCampaignEloquaQuery = void 0;

var _helpers = require("../../../../utils/helpers");

var _EmptyGatewayApi = require("../../../EmptyGatewayApi");

var eloquaDecisionServiceCampaigns = _EmptyGatewayApi.emptyGatewayApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getCampaignEloqua: build.query({
        query: function query(_ref) {
          var campaignId = _ref.campaignId;
          return "/campaigns/eloqua/".concat(campaignId);
        },
        transformResponse: function transformResponse(_ref2) {
          var data = _ref2.data,
              teams = _ref2.teams,
              users = _ref2.users,
              products = _ref2.products;
          return (0, _helpers.transformCampaigns)([data], teams, users, products)[0];
        }
      })
    };
  }
});

var useGetCampaignEloquaQuery = eloquaDecisionServiceCampaigns.useGetCampaignEloquaQuery;
exports.useGetCampaignEloquaQuery = useGetCampaignEloquaQuery;